export const MealSize = (json: IMealSize): IMealSizeModel => {
	const fromJSON = () => {
		const { is_active, ...rest } = json
		return {
			isActive: is_active,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const PriceTier = (json: IMealPriceTier): IMealPriceTierModel => {
	const {
		meal_kind,
		meal_subkind,
		meal_price_tier,
		meal_size_id,
		meal_size,
		meal_type,
		is_active,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		mealKind: meal_kind,
		mealSubkind: meal_subkind,
		mealPriceTier: meal_price_tier,
		mealSizeID: meal_size_id,
		mealSize: meal_size ? MealSize(meal_size) : null,
		mealType: meal_type,
		isActive: is_active,
		createdAt: created_at,
		updatedAt: updated_at,
		...rest,
	}
}
